exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile-photo[data-v-09b6d6ba]{width:2rem;height:2rem;margin:-.375rem 0}", ""]);

// exports
